import React, { useRef } from 'react';
import axios from 'axios';

export function FileChanger({ currentFileName, onChange }) {
  const fileFormRef = useRef(null);
  const handleFileChange = (event) => {
    if (event.target.files?.[0]) {
      const formData = new FormData(fileFormRef.current);
      axios.post(window.DjUrls['ate:update_file'](), formData).then((res) => {
        onChange(res.data);
      });
    }
  };

  return (
    <form className="flex gap-4 items-center" ref={fileFormRef}>
      Plik:
      <span
        className="truncate w-[200px] input input-sm"
        title={currentFileName}
      >
        {currentFileName}
      </span>
      <label
        htmlFor="file-input"
        className="btn btn-sm btn-primary"
        title="Zmień plik"
      >
        <input
          id="file-input"
          type="file"
          className="sr-only"
          name="datafile"
          onChange={handleFileChange}
        />
        Zmień
      </label>
    </form>
  );
}
